// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__2g7qx","bigColWidth":"Table_bigColWidth__3WF4j","biggerColWidth":"Table_biggerColWidth__30koe","row":"Table_row__nevBG","col":"Table_col__1W_KY"};